import Script from 'next/script';
import style from './style.module.scss';
import { useTranslation } from 'next-i18next';
import { useState, useEffect, useRef } from 'react';
import { useMobileSizeDetect } from '@/src/hooks/useMobileSizeDetect';

const CallPage = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const isMobileWidth = useMobileSizeDetect(1020);
  const widgetRef = useRef<HTMLDivElement>(null);

  // 5.5 IntersectionObserver: start loading widget.js 200px before it enters viewport
  useEffect(() => {
    const el = widgetRef.current;
    if (!el) return undefined;
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        setScriptLoaded(true);
        observer.disconnect();
      },
      { rootMargin: '200px' }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const handleMessage = (e: MessageEvent) => {
      if (
        e.data?.event &&
        typeof e.data.event === 'string' &&
        e.data.event.startsWith('calendly.')
      ) {
        setIsLoading(false);
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <div className={style.main}>
      <div className={style.section}>
        <div className={style.inner}>
          <div className={style.title}>{t('call_title', 'Start trading in 15 minutes')}</div>
          <div className={style.subtitle}>
            {t(
              'call_description',
              'During a personal online session, our specialist will help you set up your profile, answer your questions, and show you how to get the most out of the broker, terminal, and other Tiger.com products.'
            )}
          </div>
          <div className={style.chooseTime}>{t('call_select_time', 'Choose a time now')}</div>
          <div
            className={`${style.calendlyWrapper} ${!isLoading ? style.calendlyWrapperLoaded : ''}`}
          >
            {/* Calendly inline widget begin */}
            <div
              ref={widgetRef}
              className="calendly-inline-widget"
              data-url="https://calendly.com/d/cxn9-gkh-wm3/tiger-com"
              style={{ minWidth: isMobileWidth ? '320px' : '1000px', height: '800px' }}
            />
            {scriptLoaded && (
              <Script
                src="https://assets.calendly.com/assets/external/widget.js"
                strategy="afterInteractive"
              />
            )}
            {/* Calendly inline widget end */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallPage;
